import { Column, Entity, JoinTable, ManyToMany, ManyToOne, OneToMany } from 'typeorm';
import { Categoria } from './Categoria';
import Pergunta from './Pergunta';
import ProdutoBase from './ProdutoBase';
import Tamanho from './Tamanho';
import TamanhoPadrao from './TamanhoPadrao';
import Cardapio from './Cardapio';

@Entity()
export class Produto extends ProdutoBase {
  @ManyToOne(() => Categoria, { eager: true })
  categoria: Categoria = new Categoria();

  @OneToMany(() => Tamanho, (tamanho: Tamanho) => tamanho.produto, { cascade: true })
  tamanhos!: Tamanho[];

  @ManyToMany(() => Pergunta, { eager: true, cascade: true })
  @JoinTable({ name: 'produto_tem_perguntas' })
  perguntas!: Pergunta[];

  @ManyToMany(() => Cardapio)
  @JoinTable({ name: 'cardapio_tem_produtos' })
  cardapios!: Cardapio[];

  @Column({ default: false })
  usaTamanhosPadrao: boolean = false;

  @ManyToOne(() => TamanhoPadrao, { eager: true, cascade: true })
  tamanhoPadrao?: TamanhoPadrao;

  @Column({ default: true })
  disponivel: boolean = true;
}

export default Produto;
